import React from 'react';

import { SvgProps } from '..';

const CalendarRound = ({ scale = 1, color = '#FFFFFF', viewBox = '0 0 16 16' }: SvgProps) => {
  const width = `${scale * 16}`;
  const height = `${scale * 16}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        d="M1.75 5.34088C1.75 3.68403 3.09315 2.34088 4.75 2.34088L11.25 2.34088C12.9069 2.34088 14.25 3.68403 14.25 5.34088V11.7045C14.25 13.3614 12.9069 14.7045 11.25 14.7045H4.75C3.09315 14.7045 1.75 13.3614 1.75 11.7045V5.34088Z"
        stroke={color}
      />
      <path d="M1.75 5.97726H13.75" stroke={color} strokeLinecap="round" />
      <path d="M10.25 3.25L10.25 1.25" stroke={color} strokeLinecap="round" />
      <path d="M5.75 3.43182L5.75 1.25" stroke={color} strokeLinecap="round" />
      <circle cx="7.95508" cy="11.0908" r="0.75" fill={color} />
      <circle cx="7.95508" cy="9" r="0.75" fill={color} />
      <circle cx="5.5" cy="11.0909" r="0.75" fill={color} />
      <circle cx="5.5" cy="9" r="0.75" fill={color} />
      <circle cx="10.5" cy="11.0909" r="0.75" fill={color} />
      <circle cx="10.5" cy="9" r="0.75" fill={color} />
    </svg>
  );
};

export default CalendarRound;
